import { createStyles, makeStyles } from '@material-ui/styles';
export var useStyles = makeStyles(function () {
    return createStyles({
        container: {
            paddingLeft: '15px',
            paddingRight: '15px',
        },
    });
});
//# sourceMappingURL=Dialog.styles.js.map